import React, { useState } from "react";
import Header from "@shared/components/Atoms/Contents/Header";
import FooterMain from "@shared/components/Atoms/Contents/FooterMain";
import AdminLoader from "@shared/components/Atoms/AdminLoader";
import axios from "axios";
import { Bounce, toast, ToastContainer } from "react-toastify";
import { useTheme } from "@shared/context/ThemeContext";

const Contact = () => {
  const { theme } = useTheme();
  const [formData, setFormData] = useState({
    type: "Bug Report",
    subject: "",
    message: "",
    email: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(
        `${import.meta.env.VITE_API_URL}/basic/contact`,
        formData
      );
      if (res?.data) {
        const msg = res?.data.msg || "Feedback sent successfully!";
        toast.success(msg, {
          position: "top-center",
          autoClose: 2500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        // continue
        setFormData({
          type: "Bug Report",
          subject: "",
          message: "",
          email: "",
        });
      }
    } catch (err) {
      console.log({ err });
      const msg = err?.response?.data?.msg || "Failed to send feedback.";
      toast.error(msg, {
        position: "top-center",
        autoClose: 2500,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
    setLoading(false);
  };

  return (
    <div>
      <Header />
      <ToastContainer />
      <div id="feedback-page" className={``}>
        <div className="container mx-auto px-4 py-8">
          <div className="page-header flex justify-between items-center mb-6 mt-[50px]">
            {/* <h1 className="text-3xl font-bold">Send Feedback</h1>
            <button
              className="back-btn text-blue-600 hover:underline"
              onClick={() => window.history.back()}
              >
              ← Back
              </button> */}
          </div>
          <div className="max-w-4xl mx-auto my-10 p-8 rounded-xl">
            <h1 className="text-4xl font-bold text-gray-900 mb-6">
              Send Feedback
            </h1>
            <div className="feedback-form">
              <p className="mb-6 text-gray-700">
                Help us improve with your feedback.
              </p>

              <form className="space-y-6" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="type" className="block font-medium mb-1">
                    Feedback Type
                  </label>
                  <select
                    id="type"
                    value={formData.type}
                    onChange={handleChange}
                    className="form-input w-full border border-gray-300 rounded px-3 py-2"
                  >
                    <option value="Bug Report">Bug Report</option>
                    <option value="Feature Request">Feature Request</option>
                    <option value="General Feedback">General Feedback</option>
                    <option value="Performance Issue">Performance Issue</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="subject" className="block font-medium mb-1">
                    Subject
                  </label>
                  <input
                    type="text"
                    id="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Brief description"
                    className="form-input w-full border border-gray-300 rounded px-3 py-2"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message" className="block font-medium mb-1">
                    Message
                  </label>
                  <textarea
                    id="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={6}
                    placeholder="Tell us more about your feedback..."
                    className="form-input w-full border border-gray-300 rounded px-3 py-2"
                  />
                </div>

                {loading ? (
                  <AdminLoader />
                ) : (
                  <button
                    type="submit"
                    className="submit-btn bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
                  >
                    Send Feedback
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
      <FooterMain />
    </div>
  );
};

export default Contact;
